<template>
	<div class="body">
		<div class="career-ctr" v-if="title">
			
			<div class="cnt-nav-ctr">
				<div class="cnt-nav-inner">
					<div class="cnt-nav-item" v-for="(item, index) in navList" :key="index"
						@click="clickRoute(item)">
						
						<img :src="item.icon" class="nav-item-icon"/>
						<label :class="['nav-item-name', index == navList.length - 1 ? 'nav-item-name-selected' : '']">{{ item.name }}</label>
						
						<img src="http://syzsoss.oss-cn-chengdu.aliyuncs.com/202509/13144709-98064606215907526.png" class="nav-arrow" v-if="index != navList.length - 1"/>
					</div>
				</div>
			</div>
			
			<div class="content-title">
				<img class="title-wing" src="@/assets/icons/title_wing_left.png" />
				<span class="title-text">{{ title }}</span>
				<img class="title-wing" src="@/assets/icons/title_wing_right.png" />
			</div>

			<div class="career-cnt-ctr">
				<el-table :data="list" :span-method="spanMethod" border>
					<el-table-column label="共性行业" align="center" prop="industry_name" min-width="1" />
					<el-table-column label="岗位名称" align="center" prop="career_name" min-width="1"/>
					<el-table-column label="岗位能力" align="center" prop="task" min-width="4"/>
				</el-table>

				<div class="pagination">
					<pagination v-show="total>0" :total="total" :page.sync="queryParams.page"
						:limit.sync="queryParams.pageSize" @pagination="requestData" />
				</div>
			</div>

			<div class="action-ctr">
				<el-button type="primary" icon="el-icon-search" size="medium" @click="clickJob()">岗位市场需求分析</el-button>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		getGroupCareerData,
	} from "@/api/matrix"

	import {
		getSpanMap
	} from "@/utils/util"

	import {
		Notification,
		Message,
		Loading
	} from 'element-ui'
	
	import {
		parse,handleProtocal,handleRouteProtocal
	} from "@/utils/protocal"

	export default {
		name: "Famous",
		data() {
			return {
				title: '',
				list: [],
				spanMap: {},
				queryParams: {
					page: 1,
					pageSize: 20
				},
				total: 0,
				navList: []
			}
		},
		created() {
			this.initPageData();
		},
		methods: {
			initPageData() {
				this.requestData();
			},

			requestData() {
				this.groupId = this.$route.query.id;
				this.navList = this.getNavList(this.groupId);
				this.queryParams.group_id = this.groupId;
				getGroupCareerData(this.queryParams).then(res => {
					let realData = res.data;
					this.title = realData.title;
					this.list = realData.list;
					this.total = res.data.pageData.totalCount;

					this.spanMap = getSpanMap(this.list, ['industry_name'])
				});
			},
			
			getNavList(id){
				let list = [
					{
						'icon': 'http://syzsoss.oss-cn-chengdu.aliyuncs.com/202509/13152635-89000603806795123.png',
						'name': '专业群分析',
						'url': 'replace://matrix?activeLeftTab=4'
					},
					{
						'icon': 'http://syzsoss.oss-cn-chengdu.aliyuncs.com/202509/13152810-40724442352541210.png',
						'name': '共性行业',
						'url': 'replace://sameIndustry?id=' + id
					},
					{
						'icon': 'http://syzsoss.oss-cn-chengdu.aliyuncs.com/202509/13144254-06068696783708613.png',
						'name': '行业岗位',
						'url': ''
					}
				]
				
				return list;
			},

			spanMethod({
				row,
				column,
				rowIndex
			}) {
				const colProp = column.property // 当前列字段名
				if (this.spanMap[colProp]) {
					const rowspan = this.spanMap[colProp][rowIndex]
					return {
						rowspan,
						colspan: rowspan === 0 ? 0 : 1
					}
				}
				return {
					rowspan: 1,
					colspan: 1
				}
			},

			clickJob() {
				Message({
					message: '敬请期待',
					type: 'success'
				})
			},
			
			clickRoute(item) {
				console.log('item', item)
				let data = parse(item.url)
				if(data){
					if(data['head'] == 'replace'){
						let url = "/" + data['path'];
						if (data['data'] != null && data['data'].length != 0) {
							url += "?" + data['data'];
						}
						console.log('url', url)
						// this.$router.replace(url);
						this.$router.push(url);
					}else{
						handleRouteProtocal(data)
					}
				}

			},
		}
	}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
	@use "career.scss";
</style>